import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AdminSideBar } from "../../../modules/AdminSideBar";
import { Link } from "../../../components/Link";
import { Button } from "../../../components/Button";
import { Modal } from "../../../modules/Modal";
import { inquiry } from "../../../store";
import { getEducationReviewCategoryLabel } from "../../QnA/qnaBoardConfig";
import leftArrowButton from "../../../icons/chevron-left-large.svg";
import rightArrowButton from "../../../icons/chevron-right-large.svg";

const POSTS_PER_PAGE = 10;

const formatDate = (value) => {
  if (!value) return "-";
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? "-" : d.toLocaleDateString("ko-KR");
};

export const AdminReviews = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [targetId, setTargetId] = useState(null);
  // "delete" | "hide" (복원은 확인 없이 즉시 처리)
  const [actionType, setActionType] = useState(null);
  const navigate = useNavigate();

  const {
    isLoading,
    adminReviews,
    adminReviewsTotal,
    getAdminReviews,
    deleteAdminReview,
    updateReviewActive,
  } = inquiry((state) => ({
    isLoading: state.isLoading,
    adminReviews: state.adminReviews,
    adminReviewsTotal: state.adminReviewsTotal,
    getAdminReviews: state.getAdminReviews,
    deleteAdminReview: state.deleteAdminReview,
    updateReviewActive: state.updateReviewActive,
  }));

  const fetchPage = (page) => {
    const skip = (page - 1) * POSTS_PER_PAGE;
    getAdminReviews(skip, POSTS_PER_PAGE, "desc");
  };

  useEffect(() => {
    fetchPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    fetchPage(page);
    setCurrentPage(page);
    window.scrollTo(0, 0);
  };

  const handleDeleteClick = (id) => {
    setActionType("delete");
    setTargetId(id);
    setShowModal(true);
  };

  const handleHideClick = (id) => {
    setActionType("hide");
    setTargetId(id);
    setShowModal(true);
  };

  const handleRestoreClick = async (id) => {
    await updateReviewActive(id, true);
  };

  const closeModal = () => {
    setShowModal(false);
    setTargetId(null);
    setActionType(null);
  };

  const handleConfirm = async () => {
    if (actionType === "delete") {
      const ok = await deleteAdminReview(targetId);
      closeModal();
      if (ok) fetchPage(currentPage);
      return;
    }
    if (actionType === "hide") {
      await updateReviewActive(targetId, false);
      closeModal();
      return;
    }
    closeModal();
  };

  const totalPages = Math.ceil(adminReviewsTotal / POSTS_PER_PAGE) || 1;

  const renderPageButtons = () => {
    const pageButtons = [];
    let startPage = Math.max(currentPage - 2, 1);
    let endPage = Math.min(startPage + 4, totalPages);
    if (endPage - startPage < 4) {
      startPage = Math.max(endPage - 4, 1);
    }
    for (let i = startPage; i <= endPage; i++) {
      pageButtons.push(
        <button
          key={i}
          className={
            currentPage === i
              ? "column-pagination-page-button active"
              : "column-pagination-page-button"
          }
          onClick={() => handlePageChange(i)}
        >
          {i}
        </button>
      );
    }
    return pageButtons;
  };

  return (
    <div className="admin-background">
      <div className="layout-flex">
        <AdminSideBar />
        <main className="admin-main-content">
          <h2 className="admin-page-title">고객 후기 관리</h2>

          <div className="column-pagination-container">
            <div className="column-pagination-container-header">
              <Link
                to="/admin/reviews/new"
                label="후기 작성"
                buttonStyle="default"
                color="white"
                style={{
                  fontSize: "14px",
                  padding: "7px 20px",
                  width: "fit-content",
                  height: "fit-content",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16px"
                  height="16px"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M4 12H20M12 4V20"
                    stroke="#ffffff"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Link>
            </div>

            <div className="column-list">
              <div
                className="column-list-header"
                style={{
                  gridTemplateColumns:
                    "60px 100px 1fr 110px 110px 90px 140px",
                }}
              >
                <div>No</div>
                <div>작성자</div>
                <div>제목</div>
                <div>분류</div>
                <div>작성일자</div>
                <div>구분</div>
                <div>관리</div>
              </div>

              {isLoading ? (
                <div className="column-list-item">
                  <div></div>
                  <div>Loading...</div>
                </div>
              ) : adminReviews && adminReviews.length ? (
                adminReviews.map((review) => (
                  <div
                    key={review.id}
                    className="column-list-item"
                    style={{
                      gridTemplateColumns:
                        "60px 100px 1fr 110px 110px 90px 140px",
                    }}
                  >
                    <div>{review.id}</div>
                    <div>{review.user_name || "-"}</div>
                    <div className="column-list-title">
                      {review.is_active === false && (
                        <span
                          style={{
                            display: "inline-block",
                            marginRight: "6px",
                            padding: "1px 7px",
                            borderRadius: "4px",
                            backgroundColor: "#fde7e9",
                            color: "#c0392b",
                            fontSize: "11px",
                            fontWeight: 600,
                            verticalAlign: "middle",
                          }}
                        >
                          숨김
                        </span>
                      )}
                      <span
                        style={
                          review.is_active === false
                            ? { color: "#9095a0" }
                            : undefined
                        }
                      >
                        {review.title}
                      </span>
                    </div>
                    <div>{getEducationReviewCategoryLabel(review.category)}</div>
                    <div>{formatDate(review.created_at)}</div>
                    <div>{review.is_admin ? "관리자" : "고객"}</div>
                    <div className="column-list-actions">
                      {review.is_admin ? (
                        <>
                          <Button
                            label="수정"
                            onClick={() =>
                              navigate(`/admin/reviews/${review.id}`)
                            }
                            style={{
                              width: "60px",
                              height: "30px",
                              fontSize: "13px",
                            }}
                          />
                          <Button
                            label="삭제"
                            variant="danger"
                            onClick={() => handleDeleteClick(review.id)}
                            style={{
                              width: "60px",
                              height: "30px",
                              fontSize: "13px",
                            }}
                          />
                        </>
                      ) : review.is_active === false ? (
                        <Button
                          label="복원"
                          onClick={() => handleRestoreClick(review.id)}
                          style={{
                            width: "60px",
                            height: "30px",
                            fontSize: "13px",
                          }}
                        />
                      ) : (
                        <Button
                          label="숨김"
                          variant="danger"
                          onClick={() => handleHideClick(review.id)}
                          style={{
                            width: "60px",
                            height: "30px",
                            fontSize: "13px",
                          }}
                        />
                      )}
                    </div>
                  </div>
                ))
              ) : (
                <div className="column-list-item">
                  <div></div>
                  <div>등록된 고객 후기가 없습니다.</div>
                </div>
              )}
            </div>

            <div className="column-pagination-footer">
              <div className="column-pagination-count">
                {adminReviewsTotal || 0} results
              </div>
              <div className="column-pagination-buttons">
                <button
                  className={`column-pagination-button ${
                    currentPage === 1 ? "disabled" : ""
                  }`}
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  <img className="img-11" alt="이전" src={leftArrowButton} />
                </button>
                <div className="column-pagination-button-wrap">
                  {renderPageButtons()}
                </div>
                <button
                  className={`column-pagination-button ${
                    currentPage === totalPages || totalPages === 0
                      ? "disabled"
                      : ""
                  }`}
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages || totalPages === 0}
                >
                  <img className="img-11" alt="다음" src={rightArrowButton} />
                </button>
              </div>
            </div>
          </div>
        </main>
      </div>

      <Modal
        modalTitle={actionType === "hide" ? "고객 후기 숨김" : "고객 후기 삭제"}
        isOpen={showModal}
        onClose={closeModal}
        onConfirm={handleConfirm}
        confirmLabel={actionType === "hide" ? "숨김" : "삭제"}
      >
        {actionType === "hide" ? (
          <p>
            이 후기를 숨기면 방문자에게 노출되지 않습니다. 언제든 복원할 수
            있습니다. 숨기시겠습니까?
          </p>
        ) : (
          <p>정말 이 고객 후기를 삭제하시겠습니까?</p>
        )}
      </Modal>
    </div>
  );
};
